var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-background-overlay",style:({
    opacity: _vm.opacity,
    pointerEvents: _vm.opacity > 1 ? 'auto' : 'none'
  })})}
var staticRenderFns = []

export { render, staticRenderFns }